import React from 'react'
import { DescriptionPropsType } from './types'

// Components
import NotionRenderer from '@famiryru/react-notion-renderer'
import VideoPlayer from '@famiryru/react-famiry-video-player'

// Styles
import './styles.scss'

export default ({
  title,
  notionBlocks,
  video,
  style,
  showVideo,
  showButton,
}: DescriptionPropsType) => {
  return (
    <div
      className={'description'}
      style={showVideo ? style : { ...style, padding: '38px 35px 10px 52px' }}
    >
      <div
        className={'description__left'}
        style={showVideo ? { maxWidth: 306 } : {}}
      >
        <span
          className={'description__left-title'}
          style={
            showVideo
              ? title?.length < 14
                ? {}
                : title?.length < 28
                ? { fontSize: '36px', lineHeight: '40px' }
                : { fontSize: '30px', lineHeight: '35px' }
              : {}
          }
        >
          {title}
        </span>
        {notionBlocks ? <NotionRenderer blocks={notionBlocks} /> : null}
        {showButton ? (
          <button
            style={showVideo ? {} : { marginBottom: 20 }}
            className={'description__left-button'}
          >
            Описание урока
          </button>
        ) : null}
      </div>
      {showVideo && video ? (
        <div className={'description__right'}>
          <VideoPlayer url={video} />
        </div>
      ) : null}
    </div>
  )
}
